import { Footer } from "@/components/layout/footer";
import { RouteSeo } from "@/components/seo/route-seo";
import { benCareJsonLd } from "@/lib/seo";

export default function BenCare() {
  return (
    <div className="min-h-screen bg-[#f8f4ea] text-[#172016]">
      <RouteSeo
        title="Ben Care | Vermont Founder of Liquid Stretch"
        description="Meet Ben Care, the Vermont founder behind Liquid Stretch and the personal practice that led to a small-run hemp oil for slow stretching and body care."
        path="/ben-care"
        type="article"
        jsonLd={[benCareJsonLd]}
      />

      <main>
        <section className="bg-[#123820] text-white">
          <div className="container mx-auto px-6 py-20 md:py-28 max-w-5xl">
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#f0c766]">
              Ben Care / @_BenCare
            </p>
            <h1 className="mt-5 max-w-4xl font-serif text-4xl md:text-6xl leading-tight">
              Musing on how I am learning to allow my body to heal from Long Covid, naturally.
            </h1>
            <p className="mt-6 max-w-3xl text-lg leading-8 text-white/80">
              Ben Care is the Vermont founder behind Liquid Stretch: a personal
              practice, a long formulation process, and a slow return to listening
              to the body.
            </p>
          </div>
        </section>

        <section className="container mx-auto px-6 py-16 max-w-4xl">
          <div className="prose prose-lg max-w-none prose-headings:font-serif prose-headings:text-[#123820] prose-a:text-[#315b35]">
            <p>
              Ben's story grew from lived experience in Vermont, careful
              self-observation, formulation work, and a preference for simple tools
              that support a slower relationship with the body.
            </p>

            <p>
              Liquid Stretch grew from that same place. It is a handcrafted Vermont
              hemp oil made for stretching routines, mobility work, and slow
              body-care rituals. The language stays grounded: body awareness,
              relaxation, stretching, and gentle movement.
            </p>

            <h2>Why the Ben Care voice matters</h2>
            <p>
              Ben speaks from practice, not from a script. The same attention that
              shaped Liquid Stretch also shapes the way he writes about it: take the
              oil carefully, give it time, reduce the noise, and move without forcing
              anything.
            </p>

            <h2>Where Liquid Stretch fits</h2>
            <p>
              Liquid Stretch is part of a wider Vermont Forest ecosystem that includes
              Enhanced Biofeedback and Lay Down Now. It is the oil ritual in that
              ecosystem: slow, tactile, and intended for adults who already understand
              hemp products and want to pair them with quiet body care. LiquidStretch.com
              keeps the product and ordering path clear; the related sites carry the
              deeper method library.
            </p>

            <p>
              Follow Ben on X at{" "}
              <a href="https://x.com/_BenCare" target="_blank" rel="noreferrer">
                @_BenCare
              </a>
              , or read the formulation story behind the next Liquid Stretch direction.
            </p>
          </div>
        </section>
      </main>

      <Footer variant="brand" />
    </div>
  );
}
